import img1 from './investors/upl.png'
import img2 from './investors/vikas.png'
import img3 from './investors/nsc.png'
import img4 from './investors/suumaya.png'
import img5 from './investors/dasmesh.png'
import img6 from './investors/john dheere.png'
import img7 from './investors/saraf.png'
import img8 from './investors/shriram.png'
import img9 from './investors/bioseed.png'
import img10 from './investors/bighaat.png'
import img11 from './investors/bharatgrp.png'
import img12 from './investors/itc.png'


const investor = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12
]

export default investor;